
export const EMPTY_DATA_SEARCH_CATEGORY_REPORT = {
    from_date: null,
    to_date: null,
}
